export default __webpack_public_path__ + "static/media/minamt-icon.b92828b6.svg";